import { render, staticRenderFns } from "./pie3d.vue?vue&type=template&id=f7807c78&scoped=true"
import script from "./pie3d.vue?vue&type=script&lang=js"
export * from "./pie3d.vue?vue&type=script&lang=js"
import style0 from "./pie3d.vue?vue&type=style&index=0&id=f7807c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7807c78",
  null
  
)

export default component.exports